import { makeStyles } from 'tss-react/mui';

export const useChartStyles = makeStyles()(() => ({
  root: {
    position: 'relative',
  },
  chart: {
    svg: {
      overflow: 'visible',
    },
  },
  amountWrapper: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  amount: {},
}));
